module.exports = __webpack_public_path__ + "52fb92c3f60f077e7b9b9b97fbb5ab76.svg";